// Lab51 
function outerHeight(el) {
  const style = getComputedStyle(el);

  return (
    el.getBoundingClientRect().height +
    parseFloat(style.marginTop) +
    parseFloat(style.marginBottom)
  );
}
function getPaddingTop(element) {
  const styles = window.getComputedStyle(element);
  return parseFloat(styles.paddingTop);
}
function moveCartFooter() {
  const casiGratis = document.querySelector('.casiGratis');
  const precheck = document.querySelector('.pre-check');
  const mainCartFooter = document.querySelector('#main-cart-footer');
  const cartItemsElement = document.querySelector('.cart-items');
  let paddingTop, casiGratisHeight, precheckHeight; 
  if (cartItemsElement) {
    //paddingTop = getPaddingTop(cartItemsElement) + 310;
  } else {
    paddingTop = 0;
  }
  if (casiGratis) {
    casiGratisHeight = casiGratis.offsetHeight;
  } else {
    casiGratisHeight = 0;
  }
  if (precheck) {
    precheckHeight = precheck.offsetHeight;
  } else {
    precheckHeight = 0;
  }
  if (mainCartFooter) {
    //mainCartFooter.style.top = `${casiGratisHeight + precheckHeight + paddingTop}px`;
  }
  //console.log({ casiGratisHeight, precheckHeight, paddingTop });
}
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
    console.log('test 4');
    // envioGratis();
    if (typeof updateFreeShippingPrice === 'function') {
      updateFreeShippingPrice();
    }
    moveCartFooter();
    if (typeof wrapPacks === 'function') {
      wrapPacks();
    }
    if (typeof wrapPacksDrawer === 'function') {
      wrapPacksDrawer();
    }
    
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
      console.log('test 1');
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
    console.log('test 2');
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
    console.log('test 3');
    // envioGratis();
    console.log('test 3');
    if (typeof updateFreeShippingPrice === 'function') {
      updateFreeShippingPrice();
    }
    moveCartFooter();
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceQty = html.querySelector('cart-items');
        this.innerHTML = sourceQty.innerHTML;
      })
      .catch((e) => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
        console.log('test 6');
        moveCartFooter();
        if (typeof updateFreeShippingPrice === 'function') {
          updateFreeShippingPrice();
        }
        function fadeOutJs(el, time) {
          el.style.opacity = 1;
      
          (function fade() {
              if ((el.style.opacity -= (1 / time) * 50) < 0) {
                  el.style.display = 'none';
              } else {
                  requestAnimationFrame(fade);
              }
          })();
        }
        var elements = document.querySelectorAll('#main-cart-items .tr-loader');
        elements.forEach(function(el) {
            fadeOutJs(el, 100);
        });
        if (typeof mostrarDespachos === 'function') {
          $('#main-cart-items .tr-loader').fadeOut(100);
          setTimeout(function () {
            mostrarDespachos();
            loadTimes(header_region);
          }, 500);
        }
        if (typeof maxTime === 'function') {
          setTimeout(function () {
            maxTime(header_region);
          }, 500);
        }
        if (typeof loadTimes === 'function') {
          setTimeout(function () {
            loadTimes(header_region);
          }, 1000);
        }
        // envioGratis();

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        //errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

// if cart update
if (!customElements.get('cart-update')) {
  console.log('update cart');
}

const formatter = new Intl.NumberFormat('es-CL', {
  style: 'currency',
  currency: 'CLP'
});



// // Envio Gratis
// function envioGratis() {
//   let total, falta;
//   jQuery.get("/cart.js", function(data) {
//     total = data.total_price;
//     // remove the last 2 zeros from total
//     total = total.toString().slice(0, -2);
//     falta = free - total;
//     let faltaMoney = formatter.format(falta);
//     var porcentaje = (total * 100) / free;
//     if (falta > 0) {
//       $(".casi .falta").text(faltaMoney);
//       $('.casi .aun').show(1);
//       $('.casi .listo').hide(1);
//       $('.casi .barra .linea2').css('width', porcentaje + '%');
//       $('.casi .barra .camion').css('left', porcentaje + '%');
//     } else {
//       $('.casi .aun').hide(1);
//       $('.casi .listo').show(1);
//       $('.casi .barra .linea2').css('width', '100%');
//       $('.casi .barra .camion').css('left', '100%');
//     }
//   }, 'json');
// }

// envioGratis();

document.onload = function() {
  setTimeout(function() {
  let divCartFooter = document.getElementById('main-cart-footer');
  let divContainer = document.querySelector('form.cart .extras.extras2');

  divContainer.appendChild(divCartFooter);
  divCartFooter.style.position = 'relative';
  divCartFooter.style.opacity = 1;
  

  }, 1000);
}();
